import { call, put } from 'redux-saga/effects';
import * as packageActions from '../actions/packageActionsHelper';
import * as api from '../../api';

export function* handleGetPackages() {
    try {
        const response = yield call(api.getPackages);
        yield put(packageActions.getPackage.success(response.data));
    } catch (error) {
        yield put(packageActions.getPackage.failed(error.message));
    }
}

export function* handleGetPackageById(action) {
    try {
        const response = yield call(api.getPackageById, action.payload);
        yield put(packageActions.getPackageById.success(response.data));
    } catch (error) {
        yield put(packageActions.getPackageById.failed(error.message));
    }
}

export function* handleCreatePackage(action) {
    try {
        const response = yield call(api.createPackage, action.payload);
        yield put(packageActions.createPackage.success(response.data));
    } catch (error) {
        yield put(packageActions.createPackage.failed(error.message));
    }
}

export function* handleUpdatePackage(action) {
    try {
        const { id, data } = action.payload;
        const response = yield call(api.updatePackage, id, data);
        yield put(packageActions.updatePackage.success(response.data));
    } catch (error) {
        yield put(packageActions.updatePackage.failed(error.message));
    }
}

export function* handleDeletePackage(action) {
    try {
        const response = yield call(api.deletePackage, action.payload);
        yield put(packageActions.deletePackage.success(response.data));
    } catch (error) {
        yield put(packageActions.deletePackage.failed(error.message));
    }
}

export function* handleGetPublicPackages() {
    try {
        const response = yield call(api.getPublicPackages);
        yield put(packageActions.getPublicPackage.success(response.data));
    } catch (error) {
        yield put(packageActions.getPublicPackage.failed(error.message));
    }
}
